<div class="d-flex align-items-center">
  <div class="container">
    <div class="card login-card">
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="card-body">
            <h3 class="text-primary mb-4" translate>Sign-into-your-account</h3>
            <form action="#!" [formGroup]="this.loginForm" autocomplete="off">
              <div *ngIf="!this.toAdminLogin" class="form-group">
                <label for="userName" translate>{{userName.tittle}}</label>
                <input type="text" formControlName="userName" name="userName" id="userName" class="form-control"
                  placeholder="{{userName.placeholder | translate}}"
                  [ngClass]="{ 'is-invalid': submitted && f?.userName.errors }" (keypress)="keyPressNumbers($event)"
                  maxlength="10" appAutofocus>
                <div *ngIf="submitted && f?.userName.errors" class="invalid-feedback">
                  <div *ngIf="f?.userName.errors.required">{{userName.tittle | translate}} is required</div>
                </div>
              </div>
              <div *ngIf="this.toAdminLogin" class="form-group">
                <label for="userName" translate>{{userName.tittle}}</label>
                <input type="mail" formControlName="userName" name="userName" id="userName" class="form-control"
                  placeholder="{{userName.placeholder | translate}}"
                  [ngClass]="{ 'is-invalid': submitted && f?.userName.errors }" maxlength="50" appAutofocus>
                <div *ngIf="submitted && f?.userName.errors" class="invalid-feedback">
                  <div *ngIf="f?.userName.errors.required">{{userName.tittle | translate}} is required</div>
                  <div *ngIf="f?.userName.errors.email">Email must be a valid email address</div>
                </div>
              </div>
              <div class="form-group">
                <label for="password" translate>Password</label>
                <div class="input-group">
                  <input [type]="fieldTextType ? 'text' : 'password'" name="password" formControlName="password"
                    id="password" class="form-control iconAdd" placeholder="***********"
                    [ngClass]="{ 'is-invalid': submitted && f?.password.errors }" maxlength="20">
                  <div class="input-group-append hoverCursor" (click)="toggleFieldTextType()">
                    <span class="input-group-text iconBorder">
                      <i class="fa" [ngClass]="{
                            'fa-eye-slash': !fieldTextType,
                            'fa-eye': fieldTextType
                          }"></i>
                    </span>
                  </div>
                  <div *ngIf="submitted && f?.password.errors" class="invalid-feedback">
                    <div *ngIf="f?.password.errors.required">{{'Password' | translate}} is required</div>
                  </div>
                </div>
              </div>
              <input name="login" id="login" class="btn btn-block login-btn mt-4 mb-4" type="submit"
                value="{{'Login' | translate}}" appDebounceClick (debounceClick)="onSubmit()">
            </form>
            <div class="text-center">
              <a [routerLink]="['/Auth/ForgotPassword']" class="forgot-password-link">{{"Forgot-Password" | translate}}
                ?</a>
            </div>
            <div *ngIf="!toAdminLogin" class="text-right text-muted mt-2">
              <a class="admin-login" (click)="actions('AdminLogin')">{{"Admin" | translate}} {{"Login" | translate}}</a>
            </div>
            <div *ngIf="toAdminLogin" class="text-right text-muted mt-2">
              <a class="admin-login" (click)="actions('ShareHoldersLogin')">{{"Shareholders" | translate}}
                {{"Login" | translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
